/**
 * Indicator tiers — spec §F5.2 ("three groups … Contractual / Outcome / Other"), the
 * mockup's `IND_TIERS` order. They were three accordions, then three dropdown heads, and
 * since C3 they are three options of one `<select>`; the grouping underneath has not moved.
 * Kept out of the component file so the pane exports components only (react-refresh) and so
 * the grouping is unit-testable on its own.
 */
import type { Indicator, Tier } from '../../lib/api';

/** §F5.2 accordion order, top to bottom. */
export const TIERS: readonly Tier[] = ['contractual', 'outcome', 'other'] as const;

/**
 * Group by `indicators.tier`, preserving the server's `sort_order` inside each group.
 * An unrecognised tier falls into `other` rather than disappearing from the list.
 */
export function groupByTier(indicators: Indicator[]): Record<Tier, Indicator[]> {
  const out: Record<Tier, Indicator[]> = { contractual: [], outcome: [], other: [] };
  for (const ind of indicators) (out[ind.tier] ?? out.other).push(ind);
  return out;
}
